import { formatCurrency, getCurrencyPrecision } from '@cast/utils';

export const formatMonthlyCost = (value: number): string =>
  formatCurrency(value, {
    maximumFractionDigits: getCurrencyPrecision(value),
  });
